module.exports = __webpack_public_path__ + "images/emoji/weary.b201404b09171b367f2f.png";